import React from 'react';
import MainApp from './components/MainApp';
import { AppProvider } from './shared/context/AppContext';
import './App.css';

function App() {
  return (
    <AppProvider>
      <MainApp />
    </AppProvider>
  );
}

export default App;
